// extracted by mini-css-extract-plugin
export default {"settingsContianer":"style_settingsContianer__dK19r"};